import { Layout } from "antd";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Header from "../../../components/Header";
import { PlutoAssistant } from "../../../components/pluto/PlutoAssistant";
import { PlutoProvider } from "../../../components/pluto/PlutoProvider";
import * as gtag from "../../../lib/ga/gtag";
import { useAuth } from "../../../src/auth/useAuth";

const { Content, Footer } = Layout;

const AppLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  useEffect(() => {
    gtag.pageview(location.pathname);
  }, [location.pathname]);

  if (isLoading) return null;
  if (!isAuthenticated) return children;

  return (
    <PlutoProvider>
      <Layout style={{ minHeight: "100vh" }}>
        <Layout className="site-layout">
          <Header />
          <Content style={{ margin: "0 16px" }}>
            <div className="page">
              <div className="page-padding">{children}</div>
            </div>
          </Content>
          <Footer style={{ textAlign: "end" }}>
            Bloodline by &nbsp;
            <a href="https://eidra.com">Eidra</a>
            &nbsp; © {new Date().getFullYear()}
          </Footer>
        </Layout>
      </Layout>
      <PlutoAssistant />
    </PlutoProvider>
  );
};

export default AppLayout;
